export function EvLoadingSpinner() {
  return <div className="flex items-center justify-center h-full w-full">
    <i className="fa fa-spin fa-circle-o-notch"/>
  </div>;
}
